import Resource from './Resource'

class CountryResource extends Resource {
    async index(labId) {
        const response = await this.axios.get(`/countries/index`)
        return response.data
    }
}

export default new CountryResource()
